// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-mb-250[data-v-3a151bdc]{margin-bottom:250px!important}.v-data-table>.v-data-table__wrapper>table>tbody>tr[data-v-3a151bdc]:hover{background:#f5f5f5!important}.v-data-table>.v-data-table__wrapper>table>tbody>tr>td[data-v-3a151bdc]{background:none!important}@media (max-width:600px){.v-data-table>.v-data-table__wrapper>table>tbody>tr>td[data-v-3a151bdc]{font-size:.75rem!important}}.td_width_40[data-v-3a151bdc]{width:40%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
